import $ from "jquery";
import "jquery-easing";
import "bootstrap/dist/css/bootstrap.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "../scss/main.scss";
import "./collapse";

// jQuery to collapse the navbar on scroll

function collapseNavbar() {
  const isScrolled = $(".navbar").offset().top > 200;
  const isMobile = $(window).width() < 768;

  if (isScrolled) {
    $(".navbar-fixed-top").toggleClass("top-nav-collapse", !isMobile);
    $(".navbar-fixed-top").toggleClass("mobile-nav-collapse", isMobile);
    $(".navbar-holder").addClass("navbar-shift");
  } else {
    $(".navbar-fixed-top").removeClass("top-nav-collapse");
    $(".navbar-fixed-top").removeClass("mobile-nav-collapse");
    $(".navbar-holder").removeClass("navbar-shift");
  }
}

$(window).scroll(collapseNavbar);
$(document).ready(collapseNavbar);

// jQuery for page scrolling feature - requires jQuery Easing plugin
$(function () {
  $(document).on("click", "a.page-scroll", function (event) {
    const $anchor = $(this);
    const target = $($anchor.attr("href"));

    if (!target.length) {
      return;
    }

    event.preventDefault();
    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: target.offset().top,
        },
        1500,
        "easeInOutExpo"
      );
  });
});

// Closes the Responsive Menu on Menu Item Click
$(".navbar-collapse ul li a").click(function () {
  $(this).closest(".collapse").collapse("toggle");
});

// Show more button in featured description toggle
$(".showmore").click(function () {
  $(".showmore").addClass("vanish");
});

$(".showless").click(function () {
  $(".showmore").removeClass("vanish");
});


// Thanks Gemini for this one

$(document).ready(function () {
  const breakpoint = 768;

  // 1. Function to handle screen size changes and resets
  function handleResize() {
    const isMobile = $(window).width() < breakpoint;

    if (isMobile) {
      $(".navbar-custom").removeClass("mobile-menu-open");
      $(".navbar-custom").removeClass("mobile-menu-background-open");
    } else {
      // DESKTOP RESET: Force remove all mobile-only styling
      $("body").removeClass("no-scroll"); // Ensure scroll is enabled on desktop
      $(".collapseEnable").removeClass("collapse");
      $(".navbar-custom").removeClass("blackbox");
      $(".navbar-custom").removeClass("mobile-menu-open");
      $(".navbar-custom").removeClass("mobile-menu-background-open");
      $(".navbar-fixed-top").removeClass("top-nav-collapse");
      $(".navbar-fixed-top").removeClass("mobile-nav-collapse");
      $("#navlist").addClass("list-inline");
      $("#navlist li").removeClass("nav-links-li");

      // Ensure links are reset to desktop class
      $(".nav-links-mobile").addClass("nav-links").removeClass("nav-links-mobile");
    }
  }

  // 2. The Click Toggle Logic
  $("#hamburgerMenu, .nav-links, .nav-links-mobile, .stylized-text").click(function (e) {
    // STOP: If we are on desktop, don't toggle anything (prevents flashing)
    if ($(window).width() >= breakpoint) {
      return;
    }

    const navbar = $(".navbar-custom");

    if ($(this).hasClass("stylized-text")) {
      if (navbar.hasClass("mobile-menu-open")) {
        $("body").removeClass("no-scroll");
        navbar.removeClass("mobile-menu-background-open");
        navbar.removeClass("blackbox mobile-menu-open");
      }
      return;
    }

    // Toggle all mobile classes
    $("body").toggleClass("no-scroll");
    navbar.toggleClass("blackbox");
    const menuIsOpen = navbar.toggleClass("mobile-menu-open").hasClass("mobile-menu-open");

    if (menuIsOpen) {
      requestAnimationFrame(() => {
        if (navbar.hasClass("mobile-menu-open")) {
          navbar.addClass("mobile-menu-background-open");
        }
      });
    } else {
      navbar.removeClass("mobile-menu-background-open");
    }
  });

  // 3. Initialize
  $(window).on('resize', handleResize);
  handleResize(); // Run immediately on load
});


// Archive accordion controls

function initArchiveAccordion() {
  const toggles = Array.from(document.querySelectorAll("[data-archive-target]"));
  const panels = Array.from(document.querySelectorAll(".archiveGrid"));
  const panelTransitionDuration = 400;

  function setPanelState(panel, isOpen) {
    const toggle = toggles.find((item) => item.getAttribute("aria-controls") === panel.id);

    if (toggle) {
      toggle.setAttribute("aria-expanded", String(isOpen));
    }

    window.clearTimeout(panel.archiveCloseTimer);

    if (isOpen) {
      panel.hidden = false;
      panel.style.maxHeight = "0px";
      panel.classList.remove("archive-panel-exit");
      panel.classList.add("archive-panel-enter");

      window.requestAnimationFrame(() => {
        if (!panel.hidden) {
          panel.style.maxHeight = `${panel.scrollHeight}px`;
          panel.classList.remove("archive-panel-enter");
          panel.classList.add("archive-open");
        }
      });
      return;
    }

    if (panel.hidden) {
      return;
    }

    panel.classList.remove("archive-panel-enter", "archive-open");
    panel.classList.add("archive-panel-exit");
    panel.style.maxHeight = `${panel.scrollHeight}px`;
    panel.offsetHeight;
    window.requestAnimationFrame(() => {
      panel.style.maxHeight = "0px";
    });
    panel.archiveCloseTimer = window.setTimeout(() => {
      panel.hidden = true;
      panel.style.maxHeight = "";
      panel.classList.remove("archive-panel-exit");
    }, panelTransitionDuration);
  }

  function closeAllPanels() {
    panels.forEach((panel) => setPanelState(panel, false));
  }

  toggles.forEach((toggle) => {
    toggle.addEventListener("click", () => {
      const panel = document.getElementById(toggle.dataset.archiveTarget);
      const isOpen = panel && !panel.hidden;

      closeAllPanels();

      if (panel && !isOpen) {
        setPanelState(panel, true);
      }
    });
  });

  document.querySelectorAll("[data-archive-close]").forEach((closeButton) => {
    closeButton.addEventListener("click", () => {
      const panel = document.getElementById(closeButton.dataset.archiveClose);

      if (panel) {
        setPanelState(panel, false);
      }
    });
  });

  closeAllPanels();
}

document.addEventListener("DOMContentLoaded", initArchiveAccordion);

// Archive section hover connect arrow glyphs to mouseover

function archiveArrowStart1() {
  $("#archiveGlyph1").addClass("archiveGlyphMove");
}

function archiveArrowStart2() {
  $("#archiveGlyph2").addClass("archiveGlyphMove");
}

function archiveArrowStart3() {
  $("#archiveGlyph3").addClass("archiveGlyphMove");
}

function archiveArrowStart4() {
  $("#archiveGlyph4").addClass("archiveGlyphMove");
}

function archiveArrowStart5() {
  $("#archiveGlyph5").addClass("archiveGlyphMove");
}

function archiveArrowStart6() {
  $("#archiveGlyph6").addClass("archiveGlyphMove");
}

function archiveArrowFinish() {
  $(".archiveGlyph").removeClass("archiveGlyphMove");
}

$("#archive1").on("mouseover", archiveArrowStart1);
$("#archive1").on("mouseout", archiveArrowFinish);

$("#archive2").on("mouseover", archiveArrowStart2);
$("#archive2").on("mouseout", archiveArrowFinish);

$("#archive3").on("mouseover", archiveArrowStart3);
$("#archive3").on("mouseout", archiveArrowFinish);

$("#archive4").on("mouseover", archiveArrowStart4);
$("#archive4").on("mouseout", archiveArrowFinish);

$("#archive5").on("mouseover", archiveArrowStart5);
$("#archive5").on("mouseout", archiveArrowFinish);

$("#archive6").on("mouseover", archiveArrowStart6);
$("#archive6").on("mouseout", archiveArrowFinish);

// Releases & Productions loader using custom transformer
import renderProductions, { getFeaturedProduction } from "../productions.json";

function renderFeaturedProduction() {
  const container = document.getElementById("featured-release-container");
  const featuredRelease = getFeaturedProduction();

  if (!container) {
    return;
  }

  if (!featuredRelease) {
    container.innerHTML = "";
    return;
  }

  const detailLine = [featuredRelease.artist, featuredRelease.date]
    .filter(Boolean)
    .join(" • ");

  container.innerHTML = `
    <div class="masthead-release-content">
      <p class="mastheadSmallPara">Featured release:</p>
      <div class="mastheadTextContainer">
        <p class="mastheadText">${featuredRelease.title}</p>
      </div>
      <p class="mastheadPara">${detailLine}</p>
      <a href="#releasesAnchor" class="btn btn-default btn-lg btnAction mastheadButton page-scroll">
        <span class="btnText">Details</span>
      </a>
    </div>
  `;

  const featuredButton = container.querySelector(".mastheadButton");
  if (featuredButton) {
    featuredButton.addEventListener("click", () => {
      window.setTimeout(() => {
        featuredButton.blur();
        featuredButton.classList.remove("active");
      }, 0);
    });
  }
}

function loadProductions() {
  try {
    renderProductions("releases-container");
  } catch (error) {
    console.error("Error rendering productions:", error);
    const releasesContainer = document.getElementById("releases-container");
    if (releasesContainer) {
      releasesContainer.innerHTML =
        '<p class="text-center">Failed to load content. Please try again later.</p>';
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  renderFeaturedProduction();
  loadProductions();
  preloadImages();
  initMastheadRotator();
  initPerformanceSwipe();
});

function initMastheadRotator() {
  const rotator = document.getElementById("masthead-rotator");
  const dotsContainer = document.getElementById("masthead-rotator-dots");

  if (!rotator || !dotsContainer) {
    return;
  }

  const slides = Array.from(rotator.querySelectorAll(".masthead-slide"));
  if (slides.length < 2) {
    return;
  }

  let currentIndex = 0;
  let rotationTimer = null;

  function syncMastheadHeight() {
    rotator.style.minHeight = "360px";
  }

  function showSlide(index) {
    currentIndex = index;

    slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === index;
      slide.classList.toggle("active", isActive);
      slide.setAttribute("aria-hidden", isActive ? "false" : "true");
    });

    const dots = dotsContainer.querySelectorAll(".masthead-rotator-dot");
    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle("active", dotIndex === index);
    });

    window.requestAnimationFrame(syncMastheadHeight);
  }

  function renderDots() {
    dotsContainer.innerHTML = "";

    slides.forEach((_, index) => {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "masthead-rotator-dot";
      dot.setAttribute("aria-label", `Show slide ${index + 1}`);
      dot.addEventListener("click", () => {
        showSlide(index);
        startRotation();
      });

      if (index === currentIndex) {
        dot.classList.add("active");
      }

      dotsContainer.appendChild(dot);
    });
  }

  function startRotation() {
    if (rotationTimer) {
      window.clearInterval(rotationTimer);
    }

    rotationTimer = window.setInterval(() => {
      const nextIndex = (currentIndex + 1) % slides.length;
      showSlide(nextIndex);
    }, 8000);
  }

  rotator.addEventListener("mouseenter", () => {
    if (rotationTimer) {
      window.clearInterval(rotationTimer);
      rotationTimer = null;
    }
  });

  rotator.addEventListener("mouseleave", startRotation);

  let swipeStartX = null;
  let suppressClick = false;

  rotator.addEventListener("pointerdown", (event) => {
    swipeStartX = event.clientX;
    suppressClick = false;
  });

  rotator.addEventListener("pointerup", (event) => {
    if (swipeStartX === null) {
      return;
    }

    const swipeDistance = event.clientX - swipeStartX;
    swipeStartX = null;

    if (Math.abs(swipeDistance) < 45) {
      return;
    }

    const direction = swipeDistance < 0 ? 1 : -1;
    showSlide((currentIndex + direction + slides.length) % slides.length);
    startRotation();
    suppressClick = true;
  });

  rotator.addEventListener("pointercancel", () => {
    swipeStartX = null;
  });

  rotator.addEventListener("click", (event) => {
    if (suppressClick) {
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }
  }, true);

  const featuredCalendarContainer = document.getElementById("featured-gcal-container");
  if (featuredCalendarContainer) {
    const observer = new MutationObserver(() => {
      window.requestAnimationFrame(syncMastheadHeight);
    });

    observer.observe(featuredCalendarContainer, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  window.addEventListener("resize", syncMastheadHeight);
  window.requestAnimationFrame(syncMastheadHeight);

  renderDots();
  showSlide(0);
  startRotation();
}

function initPerformanceSwipe() {
  const carousel = document.getElementById("performancesCarousel");

  if (!carousel || !window.jQuery) {
    return;
  }

  let swipeStartX = null;
  let swipeStartY = null;
  let isSwiping = false;
  let suppressClick = false;

  carousel.addEventListener("touchstart", (event) => {
    if (event.touches.length !== 1) {
      return;
    }

    swipeStartX = event.touches[0].clientX;
    swipeStartY = event.touches[0].clientY;
    isSwiping = false;
    suppressClick = false;
  }, { passive: true });

  carousel.addEventListener("touchmove", (event) => {
    if (swipeStartX === null || event.touches.length !== 1) {
      return;
    }

    const touch = event.touches[0];
    const distanceX = touch.clientX - swipeStartX;
    const distanceY = touch.clientY - swipeStartY;

    if (Math.abs(distanceX) > Math.abs(distanceY) && Math.abs(distanceX) > 10) {
      isSwiping = true;
      event.preventDefault();
    }
  }, { passive: false });

  carousel.addEventListener("touchend", (event) => {
    if (swipeStartX === null) {
      return;
    }

    const swipeDistance = event.changedTouches[0].clientX - swipeStartX;
    swipeStartX = null;
    swipeStartY = null;

    if (!isSwiping || Math.abs(swipeDistance) < 45) {
      isSwiping = false;
      return;
    }

    window.jQuery(carousel).carousel(swipeDistance < 0 ? "next" : "prev");
    suppressClick = true;
    isSwiping = false;
  });

  carousel.addEventListener("touchcancel", () => {
    swipeStartX = null;
    swipeStartY = null;
    isSwiping = false;
  });

  carousel.addEventListener("dragstart", (event) => {
    event.preventDefault();
  });

  carousel.addEventListener("click", (event) => {
    if (suppressClick) {
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }
  }, true);
}

// Preload carousel images to prevent popping during transitions
function preloadImages() {
  const images = [
    './img/performances/1.jpg',
    './img/performances/2.jpg',
    './img/performances/3.jpg',
    './img/performances/4.jpg',
    './img/performances/6.jpg',
    './img/performances/7.jpg',
    './img/performances/8.jpg'
  ];
  images.forEach(src => {
    const img = new Image();
    img.src = src;
  });
}